<section id="select-action">
  <ul class="action-list">
    <li class="action-list-item">
      <form [formGroup]="actionForm">
        <aside class="output-mode-toggle" *ngIf="primaryEntity !== CoreEntitiesTypes.ClientCorporation">
          <label class="checkbox-label">
            <input type="radio" name="outputMode" [checked]="outputMode === 'FIELD'" (change)="setOutputMode('FIELD')">
            <span>Write to field</span>
          </label>
          <label class="checkbox-label">
            <input type="radio" name="outputMode" [checked]="outputMode === 'NOTE'" (change)="setOutputMode('NOTE')">
            <span>Write to note</span>
          </label>
        </aside>

        <mat-select
          class="full-width"
          [placeholder]="promptPlaceholder()"
          [formControl]="aiPromptControl"
          required>
          <mat-option *ngFor="let prompt of prompts" [value]="prompt.sortKey">{{prompt.title}}</mat-option>
        </mat-select>

        <ng-container *ngIf="outputMode === 'FIELD'">
          <app-paired-autocomplete
            #fieldName [selectedFieldControl]="destinationFieldControl"
            [secondaryEntityControl]="destinationEntityControl"
            [primaryEntity]="primaryEntity"
            [componentId]="'action-fieldValue'"
            [entitiesOptions]="entitiesOptions"
            [inputRequired]="true"
            [dataSourceType]="dataSourceType"
            [overlayPositioningConfig]="overlayPositioningConfig">
          </app-paired-autocomplete>
        </ng-container>

        <ng-container *ngIf="outputMode === 'NOTE'">
          <aside class="initial-action">
            <label class="other-operators">
              <input type="text" [formControl]="noteActionControl" placeholder="Action" maxlength="30" required>
              <span class="char-count" [class.over-limit]="noteActionControl.value?.length > 30">
                {{ noteActionControl.value?.length || 0 }}/30
              </span>
              <span class="field-error" *ngIf="noteActionControl.touched && noteActionControl.hasError('maxlength')">
                Action must be 30 characters or fewer
              </span>
            </label>
            <p class="note-action-hint">Comments will be populated with prompt output</p>

            <div class="checkbox-container">
              <label class="checkbox-label">
                <input type="checkbox" class="kyloe-checkbox" [formControl]="noteIsDeletedControl">
                <span>Hidden from Bullhorn view?</span>
              </label>
            </div>

            <app-action-warning-block
              [message]="noteWarningMessage"
              [actionType]="dataRulesService.actionOpName(dataRulesService.actionOperators.INSERT)"
            ></app-action-warning-block>

            <div class="message tip">
              <i class="material-icons notranslate">info</i>
              Will create a new Note associated with {{primaryEntity}} records that match your criteria.
            </div>
          </aside>
        </ng-container>
      </form>
    </li>
  </ul>
</section>
